'use strict';

const Backbone = require('backbone');
const UserRepository = require('common/domain/repository/user');

const ADMIN_ROLE = 'admin';

module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した MemberModel を定義する
     */
    kind: 'member',
    defaults: {
        user: null,
        role: 'member'
    },

    initialize: function() {
        const user = this.get('user');
        this._user = UserRepository.create(user);
    },

    idParams: function() {
        const group = this.get('group');
        return {
            member_id: this.get('id'),
            group_id: (group && group.get('id'))
        };
    },

    getRole: function() {
        return this.get('role');
    },

    isAdmin: function() {
        return (this.getRole() == ADMIN_ROLE);
    },

    toString: function (options) {
        // UserIDは省略してはいけない (一意に特定できない)
        return `@#{this.id}`;
    },

    getUser: function() {
        return this._user;
    },

    getUserID: function() {
        return this.getUser().id;
    },

    isSuspended: function() {
        return this.get('suspended') || this.getUser().isSuspended();
    },

    selected: function() {
        return this._selected;
    },

    select: function() {
        if(!this._selected) {
            this._selected = true;
            this.trigger('selected', this);
            this.trigger('change', this);
        }
    },

    deselect: function() {
        if(this._selected) {
            this._selected = false;
            this.trigger('deselected', this);
            this.trigger('change', this);
        }
    },

    toggle: function() {
        if(this.selected()) {
            this.deselect();
        } else {
            this.select();
        }
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/member.js